import data from './data.md';
import links from './links.md';
import image from './assets/hero-image.jpg';

export default {
  data,
  links,
  hero: { media: { image } },
};
